import { useReadContract } from "wagmi"

import { PoolFactory, Router } from "#/shared/constants/artifacts"
import { SwappableToken } from "#/shared/types"
import { getMezoTokenAddress, isStablePool } from "#/shared/utils"

const useSwapPool = (tokenIn: SwappableToken, tokenOut: SwappableToken) => {
  const tokenInAddress = getMezoTokenAddress(tokenIn)
  const tokenOutAddress = getMezoTokenAddress(tokenOut)

  return useReadContract({
    abi: Router.abi,
    address: Router.address,
    functionName: "poolFor",
    args: [
      tokenInAddress,
      tokenOutAddress,
      isStablePool(tokenIn, tokenOut),
      PoolFactory.address,
    ],
    query: {
      enabled: !!tokenInAddress && !!tokenOutAddress,
    },
  })
}

export default useSwapPool
